// src/AdminDashboard/components/MultiStepGameForm/steps/ColorsStep.js
import React from "react";

const ColorsStep = ({ formData, updateFormData }) => {
  const categoryNames = Object.keys(formData.gameData);

  const normalizeHex = (value) => {
    if (!value) return "";
    const v = String(value).trim();
    // Already #RRGGBB
    if (/^#[0-9a-fA-F]{6}$/.test(v)) return v;
    // RRGGBB without '#'
    if (/^[0-9a-fA-F]{6}$/.test(v)) return `#${v}`;
    // #RGB -> expand
    const m3 = v.match(/^#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])$/);
    if (m3) return `#${m3[1]}${m3[1]}${m3[2]}${m3[2]}${m3[3]}${m3[3]}`;
    return v;
  };

  const handleCategoryColorChange = (index, color) => {
    const newColors = [...formData.categoryColors];
    newColors[index] = color;
    updateFormData("categoryColors", newColors);
  };

  return (
    <div className="step-content">
      <div className="colors-intro">
        <p>All colors are in hex codes</p>
      </div>

      {categoryNames.map((categoryName, index) => (
        <div key={index} className="form-group">
          <label>
            {index === 0
              ? "CATEGORY ONE"
              : index === 1
              ? "CATEGORY TWO"
              : index === 2
              ? "CATEGORY THREE"
              : "CATEGORY FOUR"}{" "}
            BACKGROUND COLOR
          </label>
          <div className="color-input-group">
            <input
              type="color"
              value={formData.categoryColors[index]}
              onChange={(e) => handleCategoryColorChange(index, e.target.value)}
              className="color-picker"
            />
            <input
              type="text"
              value={formData.categoryColors[index]}
              onChange={(e) =>
                handleCategoryColorChange(index, e.target.value.trim())
              }
              onBlur={(e) =>
                handleCategoryColorChange(index, normalizeHex(e.target.value))
              }
              placeholder="#DE183B"
              className="hex-input"
            />
          </div>
        </div>
      ))}

      <div className="form-group">
        <label>CARD BACKGROUND COLOR</label>
        <div className="color-input-group">
          <input
            type="color"
            value={formData.cardBackgroundColor}
            onChange={(e) =>
              updateFormData("cardBackgroundColor", e.target.value)
            }
            className="color-picker"
          />
          <input
            type="text"
            value={formData.cardBackgroundColor}
            onChange={(e) =>
              updateFormData("cardBackgroundColor", e.target.value.trim())
            }
            onBlur={(e) =>
              updateFormData(
                "cardBackgroundColor",
                normalizeHex(e.target.value)
              )
            }
            placeholder="#C82C38"
            className="hex-input"
          />
        </div>
      </div>

      <div className="form-group">
        <label>CARD TEXT COLOR</label>
        <div className="color-input-group">
          <input
            type="color"
            value={formData.cardTextColor}
            onChange={(e) => updateFormData("cardTextColor", e.target.value)}
            className="color-picker"
          />
          <input
            type="text"
            value={formData.cardTextColor}
            onChange={(e) =>
              updateFormData("cardTextColor", e.target.value.trim())
            }
            onBlur={(e) =>
              updateFormData("cardTextColor", normalizeHex(e.target.value))
            }
            placeholder="#FFFFFF"
            className="hex-input"
          />
        </div>
      </div>

      <div className="form-group">
        <label>CATEGORY TEXT COLOR</label>
        <div className="color-input-group">
          <input
            type="color"
            value={formData.categoryTextColor}
            onChange={(e) =>
              updateFormData("categoryTextColor", e.target.value)
            }
            className="color-picker"
          />
          <input
            type="text"
            value={formData.categoryTextColor}
            onChange={(e) =>
              updateFormData("categoryTextColor", e.target.value.trim())
            }
            onBlur={(e) =>
              updateFormData("categoryTextColor", normalizeHex(e.target.value))
            }
            placeholder="#FFFFFF"
            className="hex-input"
          />
        </div>
      </div>
    </div>
  );
};

export default ColorsStep;
